import {
  FlexRow,
  MaterialIcon,
  StyledButton,
  StyledSearchBar,
  useDebouncedSearch,
  useModal,
} from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import {
  installationCampaignState,
  installationDateRangeState,
  installationDownloadListState,
  installationFilterGdlStatusState,
  installationFilterJobType,
  installationFilterGnpStatusState,
  installationIvrState,
  installationReloadListState,
  installationSearchState,
  tableColumnsState,
  installationFilterHdiStatusState,
} from '../../storage/Installations';
import StyledTooltip from '../ui/StyledTooltip';
import InstallationFilters from './InstallationFilters';
import CreateInstallationModal from './modal/CreateInstallationModal';

function InstalltionsFiltersBar() {
  const { css, theme } = useStyles();
  const [searchParams] = useSearchParams();
  const { search, setSearch } = useDebouncedSearch(useRecoilState(installationSearchState));
  const setReloadPage = useSetRecoilState(installationReloadListState);
  const setDownloadPage = useSetRecoilState(installationDownloadListState);
  const resetSelectCampaign = useResetRecoilState(installationCampaignState);
  const resetSearch = useResetRecoilState(installationSearchState);
  const resetSort = useResetRecoilState(tableColumnsState);
  const resetInstallationDateRange = useResetRecoilState(installationDateRangeState);
  const resetIvr = useResetRecoilState(installationIvrState);
  const resetSelectGnpStatus = useResetRecoilState(installationFilterGnpStatusState);
  const resetSelectGdlStatus = useResetRecoilState(installationFilterGdlStatusState);
  const resetSelectHdiStatus = useResetRecoilState(installationFilterHdiStatusState);
  const resetSelectJobType = useResetRecoilState(installationFilterJobType);
  const { showModal, openModal, closeModal } = useModal();
  const q = searchParams.get('q');

  useEffect(() => {
    if (q) {
      setSearch(q || '');
    }
  }, [q]);

  const resetFilters = () => {
    resetSearch();
    resetSort();
    resetInstallationDateRange();
    resetSelectCampaign();
    resetIvr();
    resetSelectJobType();
    resetSelectGdlStatus();
    resetSelectGnpStatus();
    resetSelectHdiStatus();
  };

  return (
    <FlexRow
      classNames={css({ alignItems: 'center' })}
      gap={'4px'}
    >
      <FlexRow
        classNames={css({ flex: '1', alignItems: 'center' })}
        gap={'4px'}
      >
        <span className={css({ flexGrow: '0.5' })}>
          <StyledSearchBar
            name={'convoy-search'}
            value={search}
            onChange={setSearch}
            clearable
            noMargin
          />
        </span>
        <InstallationFilters />
        <StyledTooltip
          content={'Limpiar filtros'}
          showArrow={false}
        >
          <Button
            size="mini"
            shape="round"
            onClick={resetFilters}
            kind="tertiary"
          >
            <MaterialIcon
              name={'clear'}
              size="mini"
            />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <StyledTooltip
        content={'Descargar'}
        showArrow={false}
      >
        <Button
          size="mini"
          shape="round"
          onClick={() => setDownloadPage(true)}
          kind="tertiary"
        >
          <MaterialIcon
            name={'download_for_offline'}
            size="mini"
          />
        </Button>
      </StyledTooltip>
      <StyledTooltip
        content={'Actualizar lista'}
        showArrow={false}
      >
        <Button
          size="mini"
          shape="round"
          onClick={() => setReloadPage((prev) => !prev)}
          kind="tertiary"
        >
          <MaterialIcon
            name={'refresh'}
            size="mini"
          />
        </Button>
      </StyledTooltip>
      <StyledButton
        onClick={openModal}
        startEnhancer={
          <MaterialIcon
            name="add"
            size="xs-mini"
            color={theme.colors.contentInversePrimary}
          />
        }
      >
        Nueva
      </StyledButton>
      <CreateInstallationModal
        isOpen={showModal}
        onClose={closeModal}
      />
    </FlexRow>
  );
}

export default memo(InstalltionsFiltersBar);
